import Vue from "vue";
import Icon from "../components/Icon";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAngleDown,
  faAngleUp,
  faArrows,
  faAward,
  faBoxes,
  faBars,
  faShoppingCart,
  faCheck,
  faCheckCircle,
  faChevronRight,
  faChevronLeft,
  faCog,
  faClipboard,
  faCreditCard,
  faDownload,
  faExclamationCircle,
  faEye,
  faExpandArrows,
  faExpandArrowsAlt,
  faIdCard,
  faUsersClass,
  faFile,
  faCloudUpload,
  faInfoCircle,
  faListAlt,
  faMinus,
  faPaperPlane,
  faPencil,
  faPlus,
  faRulerCombined,
  faSearch,
  faSpinner,
  faSpinnerThird,
  faTimes,
  faTrashAlt,
  faUsers,
  faUserClock,
  faUserLock
} from "@fortawesome/pro-regular-svg-icons";

library.add(
  faAngleDown,
  faAngleUp,
  faArrows,
  faAward,
  faBoxes,
  faBars,
  faShoppingCart,
  faCheck,
  faCheckCircle,
  faChevronRight,
  faChevronLeft,
  faCog,
  faClipboard,
  faCreditCard,
  faDownload,
  faExclamationCircle,
  faEye,
  faExpandArrows,
  faExpandArrowsAlt,
  faIdCard,
  faUsersClass,
  faFile,
  faCloudUpload,
  faInfoCircle,
  faListAlt,
  faMinus,
  faPaperPlane,
  faPencil,
  faPlus,
  faRulerCombined,
  faSearch,
  faSpinner,
  faSpinnerThird,
  faTimes,
  faTrashAlt,
  faUsers,
  faUserClock,
  faUserLock
);

Vue.component("Icon", Icon);
